// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overview .overview-groups {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.overview .overview-group {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}
.overview .overview-group-tests {
  flex-direction: column;
  flex-wrap: nowrap;
}
.overview .overview-group-tests .overview-card {
  flex: 1 1 100%;
  width: 100%;
}
.overview .overview-card {
  flex: 1 1 260px;
  min-width: 240px;
  padding: 1rem;
  border-radius: 4px;
}
.overview .overview-title {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
}
.overview .overview-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
}
.overview .overview-title-left {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}
.overview .overview-title-left button[mat-icon-button] {
  width: 32px;
  height: 32px;
  line-height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.overview .overview-title-actions {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
}
.overview .btn-icon {
  padding: 0.2rem 0.4rem;
  line-height: 1;
  background: none;
  border: 1px solid transparent;
}
.overview .btn-icon:hover:not(:disabled) {
  background-color: rgba(0, 0, 0, 0.05);
  border-color: rgba(0, 0, 0, 0.1);
}
.overview .overview-rows {
  margin: 0;
}
.overview .overview-rows .overview-row {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.25rem 0;
}
.overview .overview-rows .row-label {
  margin: 0;
  font-weight: 500;
  color: #555;
}
.overview .overview-rows .row-value {
  margin: 0;
  text-align: right;
}
.overview .overview-measured .row-value {
  font-variant-numeric: tabular-nums;
  font-weight: 600;
}
.overview .overview-tests {
  list-style: none;
  margin: 0;
  padding: 0;
}
.overview .overview-tests .overview-test {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.25rem 0;
}
.overview .overview-tests .overview-test-empty {
  padding: 0.35rem 0;
  font-size: 0.9rem;
}
.overview .overview-tests .test-toggle {
  border: 0;
  background: transparent;
  width: 100%;
  padding: 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  text-align: left;
}
.overview .overview-tests .test-expand-indicator {
  display: inline-block;
  width: 12px;
  color: #666;
  transform: rotate(0deg);
  transition: transform 0.2s ease;
}
.overview .overview-tests .test-expand-indicator.expanded {
  transform: rotate(90deg);
}
.overview .overview-tests .test-title {
  flex: 1;
}
.overview .overview-tests .test-status {
  color: #555;
  font-size: 0.85rem;
}
.overview .overview-tests .test-start {
  flex: 0 0 auto;
  line-height: 1.2;
  padding: 0.2rem 0.6rem;
}
.overview .overview-tests .overview-test-details {
  margin: 0.2rem 0 0.55rem 1.45rem;
  padding: 0.6rem;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  background: #f8fafc;
}
.overview .overview-tests .test-detail-summary {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.9rem;
}
.overview .overview-tests .test-input-lock-note {
  margin-bottom: 0.55rem;
  font-size: 0.82rem;
  color: #7a4b08;
  background: #fff7ed;
  border: 1px solid #fed7aa;
  border-radius: 4px;
  padding: 0.35rem 0.5rem;
}
.overview .overview-tests .test-input-fieldset {
  border: 0;
  margin: 0;
  padding: 0;
  min-width: 0;
}
.overview .overview-tests .test-input-fieldset:disabled {
  opacity: 0.75;
}
.overview .overview-tests .test-detail-footer {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
  justify-content: flex-end;
}
.overview .overview-tests .test-attachments {
  width: 100%;
  margin-bottom: 0.5rem;
  border-top: 1px solid #e2e8f0;
  padding-top: 0.6rem;
}
.overview .overview-tests .test-attachments-label {
  display: flex;
  align-items: center;
  gap: 0.2rem;
  font-size: 0.8rem;
  font-weight: 600;
  color: #64748b;
  margin-bottom: 0.35rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.overview .overview-tests .test-attachments-icon {
  font-size: 0.95rem;
  width: 0.95rem;
  height: 0.95rem;
}
.overview .overview-tests .test-attachments-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}
.overview .overview-tests .test-attachment-link {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  background: none;
  border: none;
  padding: 0.1rem 0.25rem;
  cursor: pointer;
  color: #2563eb;
  font-size: 0.875rem;
  border-radius: 3px;
  transition: background 0.15s;
}
.overview .overview-tests .test-attachment-link:hover:not(:disabled) {
  background: #eff6ff;
  text-decoration: underline;
}
.overview .overview-tests .test-attachment-link:disabled {
  opacity: 0.6;
  cursor: default;
}
.overview .overview-tests .test-attachment-file-icon {
  font-size: 0.95rem;
  width: 0.95rem;
  height: 0.95rem;
  color: #64748b;
}
.overview .overview-tests .test-row-error {
  color: #b42318;
  font-size: 0.8rem;
}
.overview .overview-tests .test-detail-sections {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.overview .overview-tests .pycnometer-panel {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}
.overview .overview-tests .pycnometer-profile-picker {
  border: 1px solid #e3e8ef;
  border-radius: 4px;
  padding: 0.65rem;
  background: #ffffff;
}
.overview .overview-tests .pycnometer-profile-list {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
}
.overview .overview-tests .pycnometer-profile-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.75rem;
  padding: 0.35rem 0;
  border-bottom: 1px dashed #d7e0ea;
}
.overview .overview-tests .pycnometer-profile-item:last-child {
  border-bottom: 0;
  padding-bottom: 0;
}
.overview .overview-tests .pycnometer-runs-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 0.75rem;
}
.overview .overview-tests .pycnometer-run-card {
  border: 1px solid #d9e2ec;
  border-radius: 4px;
  padding: 0.6rem;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
}
.overview .overview-tests .pycnometer-run-title {
  font-weight: 700;
  color: #334155;
  font-size: 0.82rem;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}
.overview .overview-tests .density-panel {
  background: #ffffff;
}
.overview .overview-tests .density-fields {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 0.65rem 1rem;
}
.overview .overview-tests .rheology-matrix {
  display: grid;
  grid-template-columns: minmax(120px, 1.1fr) repeat(3, minmax(120px, 1fr));
  gap: 0.45rem 0.55rem;
  align-items: center;
}
.overview .overview-tests .rheology-header {
  font-size: 0.83rem;
  font-weight: 700;
  color: #334155;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  padding-bottom: 0.2rem;
  border-bottom: 1px solid #d9e2ec;
}
.overview .overview-tests .row-label-column {
  text-transform: none;
}
.overview .overview-tests .rheology-row-label {
  font-size: 0.82rem;
  color: #475569;
  font-weight: 600;
}
.overview .overview-tests .rheology-cell {
  min-width: 0;
}
.overview .overview-tests .test-detail-section {
  border: 1px solid #e3e8ef;
  border-radius: 4px;
  padding: 0.65rem;
  background: #ffffff;
}
.overview .overview-tests .test-detail-title {
  margin: 0 0 0.55rem;
  font-size: 0.85rem;
  font-weight: 700;
  color: #3f4954;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}
.overview .overview-tests .test-detail-fields {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 0.65rem 1rem;
}
.overview .overview-tests .test-detail-field {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}
.overview .overview-tests .test-detail-label {
  margin: 0;
  font-size: 0.85rem;
  color: #555;
  font-weight: 600;
}
@media (max-width: 680px) {
  .overview .overview-tests .rheology-matrix {
    overflow-x: auto;
    display: block;
  }
  .overview .overview-tests .rheology-matrix > * {
    min-width: 520px;
  }
}
.overview .status-dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex: 0 0 auto;
}
.overview .status-pass {
  background-color: #28a745;
}
.overview .status-fail {
  background-color: #dc3545;
}
.overview .status-pending {
  background-color: #ffc107;
}
.overview .status-unknown {
  background-color: #6c757d;
}
.overview .add-test-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
  padding: 1rem;
}
.overview .add-test-modal {
  width: min(560px, 100%);
  max-height: calc(100vh - 2rem);
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 18px 44px rgba(15, 23, 42, 0.24);
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
  overflow-y: auto;
}
.overview .add-test-modal-title {
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
  color: #1f2937;
}
.overview .add-test-modal-field {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}
.overview .add-test-modal-field .select-wrapper {
  position: relative;
}
.overview .add-test-modal-field .select-wrapper select.form-control {
  appearance: none;
  padding-right: 2.5rem;
}
.overview .add-test-modal-field .select-wrapper::after {
  content: "";
  position: absolute;
  right: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 8px solid #555;
  pointer-events: none;
}
.overview .add-test-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
}
.overview .add-test-readings {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}
.overview .add-test-readings-row {
  display: grid;
  grid-template-columns: 1fr 1fr 40px;
  gap: 0.5rem;
  align-items: center;
}
.overview .add-test-readings-header {
  font-size: 0.8rem;
  font-weight: 600;
  color: #4b5563;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/job-details/job-request-overview/job-request-overview.component.scss"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAAJ;AAGE;EACE,aAAA;EACA,eAAA;EACA,SAAA;AADJ;AAIE;EACE,sBAAA;EACA,iBAAA;AAFJ;AAKE;EACE,cAAA;EACA,WAAA;AAHJ;AAME;EACE,eAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;AAJJ;AAOE;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;AALJ;AAQE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;EACA,sBAAA;AANJ;AASE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AAPJ;AASI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAPN;AAWE;EACE,aAAA;EACA,WAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;AATJ;AAYE;EACE,sBAAA;EACA,cAAA;EACA,gBAAA;EACA,6BAAA;AAVJ;AAYI;EACE,qCAAA;EACA,gCAAA;AAVN;AAcE;EACE,SAAA;AAZJ;AAcI;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;AAZN;AAeI;EACE,SAAA;EACA,gBAAA;EACA,WAAA;AAbN;AAgBI;EACE,SAAA;EACA,iBAAA;AAdN;AAkBE;EACE,kCAAA;EACA,gBAAA;AAhBJ;AAmBE;EACE,gBAAA;EACA,SAAA;EACA,UAAA;AAjBJ;AAmBI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;EACA,kBAAA;AAjBN;AAoBI;EACE,kBAAA;EACA,iBAAA;AAlBN;AAqBI;EACE,SAAA;EACA,uBAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;AAnBN;AAsBI;EACE,qBAAA;EACA,WAAA;EACA,WAAA;EACA,uBAAA;EACA,+BAAA;AApBN;AAsBM;EACE,wBAAA;AApBR;AAwBI;EACE,OAAA;AAtBN;AAyBI;EACE,WAAA;EACA,kBAAA;AAvBN;AA0BI;EACE,cAAA;EACA,gBAAA;EACA,sBAAA;AAxBN;AA2BI;EACE,gCAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AAzBN;AA4BI;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;AA1BN;AA6BI;EACE,sBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,uBAAA;AA3BN;AA8BI;EACE,SAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;AA5BN;AA+BI;EACE,aAAA;AA7BN;AAgCM;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;AA9BR;AAiCM;EACE,WAAA;EACA,qBAAA;EACA,6BAAA;EACA,mBAAA;AA/BR;AAkCM;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,yBAAA;EACA,sBAAA;AAhCR;AAmCM;EACE,kBAAA;EACA,cAAA;EACA,eAAA;AAjCR;AAoCM;EACE,gBAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AAlCR;AAqCM;EACE,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,4BAAA;AAnCR;AAqCQ;EACE,mBAAA;EACA,0BAAA;AAnCV;AAsCQ;EACE,YAAA;EACA,eAAA;AApCV;AAwCM;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;AAtCR;AAyCM;EACE,cAAA;EACA,iBAAA;AAvCR;AA0CI;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AAxCN;AA2CI;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AAzCN;AA4CI;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AA1CN;AA6CI;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AA3CN;AA8CI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,iCAAA;AA5CN;AA+CI;EACE,gBAAA;EACA,iBAAA;AA7CN;AAgDI;EACE,aAAA;EACA,2DAAA;EACA,YAAA;AA9CN;AAiDI;EACE,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AA/CN;AAkDI;EACE,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;AAhDN;AAmDI;EACE,mBAAA;AAjDN;AAoDI;EACE,aAAA;EACA,2DAAA;EACA,iBAAA;AAlDN;AAqDI;EACE,aAAA;EACA,yEAAA;EACA,oBAAA;EACA,mBAAA;AAnDN;AAsDI;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;EACA,sBAAA;EACA,gCAAA;AApDN;AAuDI;EACE,oBAAA;AArDN;AAwDI;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;AAtDN;AAyDI;EACE,YAAA;AAvDN;AA0DI;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAxDN;AA2DI;EACE,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;AAzDN;AA4DI;EACE,aAAA;EACA,2DAAA;EACA,iBAAA;AA1DN;AA6DI;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AA3DN;AA8DI;EACE,SAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;AA5DN;AA+DI;EACE;IACE,gBAAA;IACA,cAAA;EA7DN;EAgEI;IACE,gBAAA;EA9DN;AACF;AAkEE;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;AAhEJ;AAmEE;EAAkB,yBAAA;AAhEpB;AAiEE;EAAkB,yBAAA;AA9DpB;AA+DE;EAAkB,yBAAA;AA5DpB;AA6DE;EAAkB,yBAAA;AA1DpB;AA4DE;EACE,eAAA;EACA,QAAA;EACA,kCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,aAAA;AA1DJ;AA6DE;EACE,uBAAA;EACA,8BAAA;EACA,gBAAA;EACA,kBAAA;EACA,8CAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;AA3DJ;AA8DE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AA5DJ;AA+DE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AA7DJ;AA+DI;EACE,kBAAA;AA7DN;AA+DM;EAGE,gBAAA;EACA,qBAAA;AA7DR;AAgEM;EACE,WAAA;EACA,kBAAA;EACA,cAAA;EACA,QAAA;EACA,2BAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,mCAAA;EACA,0BAAA;EACA,oBAAA;AA9DR;AAmEE;EACE,aAAA;EACA,yBAAA;EACA,WAAA;AAjEJ;AAoEE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AAlEJ;AAqEE;EACE,aAAA;EACA,mCAAA;EACA,WAAA;EACA,mBAAA;AAnEJ;AAsEE;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;AApEJ","sourcesContent":[".overview {\n  .overview-groups {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  .overview-group {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 1rem;\n  }\n\n  .overview-group-tests {\n    flex-direction: column;\n    flex-wrap: nowrap;\n  }\n\n  .overview-group-tests .overview-card {\n    flex: 1 1 100%;\n    width: 100%;\n  }\n\n  .overview-card {\n    flex: 1 1 260px;\n    min-width: 240px;\n    padding: 1rem;\n    border-radius: 4px;\n  }\n\n  .overview-title {\n    margin: 0;\n    font-size: 1.25rem;\n    font-weight: 600;\n  }\n\n  .overview-title-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 0.75rem;\n    margin-bottom: 0.75rem;\n  }\n\n  .overview-title-left {\n    display: flex;\n    align-items: center;\n    gap: 0.25rem;\n\n    button[mat-icon-button] {\n      width: 32px;\n      height: 32px;\n      line-height: 32px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n  }\n\n  .overview-title-actions {\n    display: flex;\n    gap: 0.5rem;\n    flex-wrap: wrap;\n    justify-content: flex-end;\n    align-items: center;\n  }\n\n  .btn-icon {\n    padding: 0.2rem 0.4rem;\n    line-height: 1;\n    background: none;\n    border: 1px solid transparent;\n\n    &:hover:not(:disabled) {\n      background-color: rgba(0, 0, 0, 0.05);\n      border-color: rgba(0, 0, 0, 0.1);\n    }\n  }\n\n  .overview-rows {\n    margin: 0;\n\n    .overview-row {\n      display: flex;\n      justify-content: space-between;\n      gap: 1rem;\n      padding: 0.25rem 0;\n    }\n\n    .row-label {\n      margin: 0;\n      font-weight: 500;\n      color: #555;\n    }\n\n    .row-value {\n      margin: 0;\n      text-align: right;\n    }\n  }\n\n  .overview-measured .row-value {\n    font-variant-numeric: tabular-nums;\n    font-weight: 600;\n  }\n\n  .overview-tests {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n\n    .overview-test {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      gap: 0.75rem;\n      padding: 0.25rem 0;\n    }\n\n    .overview-test-empty {\n      padding: 0.35rem 0;\n      font-size: 0.9rem;\n    }\n\n    .test-toggle {\n      border: 0;\n      background: transparent;\n      width: 100%;\n      padding: 0;\n      display: flex;\n      align-items: center;\n      gap: 0.5rem;\n      text-align: left;\n    }\n\n    .test-expand-indicator {\n      display: inline-block;\n      width: 12px;\n      color: #666;\n      transform: rotate(0deg);\n      transition: transform 0.2s ease;\n\n      &.expanded {\n        transform: rotate(90deg);\n      }\n    }\n\n    .test-title {\n      flex: 1;\n    }\n\n    .test-status {\n      color: #555;\n      font-size: 0.85rem;\n    }\n\n    .test-start {\n      flex: 0 0 auto;\n      line-height: 1.2;\n      padding: 0.2rem 0.6rem;\n    }\n\n    .overview-test-details {\n      margin: 0.2rem 0 0.55rem 1.45rem;\n      padding: 0.6rem;\n      border: 1px solid #e2e8f0;\n      border-radius: 4px;\n      background: #f8fafc;\n    }\n\n    .test-detail-summary {\n      display: flex;\n      align-items: center;\n      gap: 0.4rem;\n      font-size: 0.9rem;\n    }\n\n    .test-input-lock-note {\n      margin-bottom: 0.55rem;\n      font-size: 0.82rem;\n      color: #7a4b08;\n      background: #fff7ed;\n      border: 1px solid #fed7aa;\n      border-radius: 4px;\n      padding: 0.35rem 0.5rem;\n    }\n\n    .test-input-fieldset {\n      border: 0;\n      margin: 0;\n      padding: 0;\n      min-width: 0;\n    }\n\n    .test-input-fieldset:disabled {\n      opacity: 0.75;\n    }\n\n      .test-detail-footer {\n        display: flex;\n        align-items: center;\n        gap: 0.75rem;\n        flex-wrap: wrap;\n        justify-content: flex-end;\n      }\n\n      .test-attachments {\n        width: 100%;\n        margin-bottom: 0.5rem;\n        border-top: 1px solid #e2e8f0;\n        padding-top: 0.6rem;\n      }\n\n      .test-attachments-label {\n        display: flex;\n        align-items: center;\n        gap: 0.2rem;\n        font-size: 0.8rem;\n        font-weight: 600;\n        color: #64748b;\n        margin-bottom: 0.35rem;\n        text-transform: uppercase;\n        letter-spacing: 0.04em;\n      }\n\n      .test-attachments-icon {\n        font-size: 0.95rem;\n        width: 0.95rem;\n        height: 0.95rem;\n      }\n\n      .test-attachments-list {\n        list-style: none;\n        padding: 0;\n        margin: 0;\n        display: flex;\n        flex-direction: column;\n        gap: 0.2rem;\n      }\n\n      .test-attachment-link {\n        display: inline-flex;\n        align-items: center;\n        gap: 0.3rem;\n        background: none;\n        border: none;\n        padding: 0.1rem 0.25rem;\n        cursor: pointer;\n        color: #2563eb;\n        font-size: 0.875rem;\n        border-radius: 3px;\n        transition: background 0.15s;\n\n        &:hover:not(:disabled) {\n          background: #eff6ff;\n          text-decoration: underline;\n        }\n\n        &:disabled {\n          opacity: 0.6;\n          cursor: default;\n        }\n      }\n\n      .test-attachment-file-icon {\n        font-size: 0.95rem;\n        width: 0.95rem;\n        height: 0.95rem;\n        color: #64748b;\n      }\n\n      .test-row-error {\n        color: #b42318;\n        font-size: 0.8rem;\n      }\n\n    .test-detail-sections {\n      display: flex;\n      flex-direction: column;\n      gap: 0.75rem;\n    }\n\n    .pycnometer-panel {\n      display: flex;\n      flex-direction: column;\n      gap: 0.85rem;\n    }\n\n    .pycnometer-profile-picker {\n      border: 1px solid #e3e8ef;\n      border-radius: 4px;\n      padding: 0.65rem;\n      background: #ffffff;\n    }\n\n    .pycnometer-profile-list {\n      display: flex;\n      flex-direction: column;\n      gap: 0.45rem;\n    }\n\n    .pycnometer-profile-item {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      gap: 0.75rem;\n      padding: 0.35rem 0;\n      border-bottom: 1px dashed #d7e0ea;\n    }\n\n    .pycnometer-profile-item:last-child {\n      border-bottom: 0;\n      padding-bottom: 0;\n    }\n\n    .pycnometer-runs-grid {\n      display: grid;\n      grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n      gap: 0.75rem;\n    }\n\n    .pycnometer-run-card {\n      border: 1px solid #d9e2ec;\n      border-radius: 4px;\n      padding: 0.6rem;\n      background: #ffffff;\n      display: flex;\n      flex-direction: column;\n      gap: 0.45rem;\n    }\n\n    .pycnometer-run-title {\n      font-weight: 700;\n      color: #334155;\n      font-size: 0.82rem;\n      text-transform: uppercase;\n      letter-spacing: 0.02em;\n    }\n\n    .density-panel {\n      background: #ffffff;\n    }\n\n    .density-fields {\n      display: grid;\n      grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n      gap: 0.65rem 1rem;\n    }\n\n    .rheology-matrix {\n      display: grid;\n      grid-template-columns: minmax(120px, 1.1fr) repeat(3, minmax(120px, 1fr));\n      gap: 0.45rem 0.55rem;\n      align-items: center;\n    }\n\n    .rheology-header {\n      font-size: 0.83rem;\n      font-weight: 700;\n      color: #334155;\n      text-transform: uppercase;\n      letter-spacing: 0.02em;\n      padding-bottom: 0.2rem;\n      border-bottom: 1px solid #d9e2ec;\n    }\n\n    .row-label-column {\n      text-transform: none;\n    }\n\n    .rheology-row-label {\n      font-size: 0.82rem;\n      color: #475569;\n      font-weight: 600;\n    }\n\n    .rheology-cell {\n      min-width: 0;\n    }\n\n    .test-detail-section {\n      border: 1px solid #e3e8ef;\n      border-radius: 4px;\n      padding: 0.65rem;\n      background: #ffffff;\n    }\n\n    .test-detail-title {\n      margin: 0 0 0.55rem;\n      font-size: 0.85rem;\n      font-weight: 700;\n      color: #3f4954;\n      text-transform: uppercase;\n      letter-spacing: 0.02em;\n    }\n\n    .test-detail-fields {\n      display: grid;\n      grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n      gap: 0.65rem 1rem;\n    }\n\n    .test-detail-field {\n      display: flex;\n      flex-direction: column;\n      gap: 0.3rem;\n    }\n\n    .test-detail-label {\n      margin: 0;\n      font-size: 0.85rem;\n      color: #555;\n      font-weight: 600;\n    }\n\n    @media (max-width: 680px) {\n      .rheology-matrix {\n        overflow-x: auto;\n        display: block;\n      }\n\n      .rheology-matrix > * {\n        min-width: 520px;\n      }\n    }\n  }\n\n  .status-dot {\n    display: inline-block;\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    flex: 0 0 auto;\n  }\n\n  .status-pass    { background-color: #28a745; }\n  .status-fail    { background-color: #dc3545; }\n  .status-pending { background-color: #ffc107; }\n  .status-unknown { background-color: #6c757d; }\n\n  .add-test-modal-backdrop {\n    position: fixed;\n    inset: 0;\n    background: rgba(15, 23, 42, 0.45);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1050;\n    padding: 1rem;\n  }\n\n  .add-test-modal {\n    width: min(560px, 100%);\n    max-height: calc(100vh - 2rem);\n    background: #fff;\n    border-radius: 8px;\n    box-shadow: 0 18px 44px rgba(15, 23, 42, 0.24);\n    padding: 1rem;\n    display: flex;\n    flex-direction: column;\n    gap: 0.85rem;\n    overflow-y: auto;\n  }\n\n  .add-test-modal-title {\n    margin: 0;\n    font-size: 1rem;\n    font-weight: 700;\n    color: #1f2937;\n  }\n\n  .add-test-modal-field {\n    display: flex;\n    flex-direction: column;\n    gap: 0.35rem;\n\n    .select-wrapper {\n      position: relative;\n\n      select.form-control {\n        -webkit-appearance: none;\n        -moz-appearance: none;\n        appearance: none;\n        padding-right: 2.5rem;\n      }\n\n      &::after {\n        content: '';\n        position: absolute;\n        right: 0.75rem;\n        top: 50%;\n        transform: translateY(-50%);\n        width: 0;\n        height: 0;\n        border-left: 6px solid transparent;\n        border-right: 6px solid transparent;\n        border-top: 8px solid #555;\n        pointer-events: none;\n      }\n    }\n  }\n\n  .add-test-modal-actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 0.5rem;\n  }\n\n  .add-test-readings {\n    display: flex;\n    flex-direction: column;\n    gap: 0.35rem;\n  }\n\n  .add-test-readings-row {\n    display: grid;\n    grid-template-columns: 1fr 1fr 40px;\n    gap: 0.5rem;\n    align-items: center;\n  }\n\n  .add-test-readings-header {\n    font-size: 0.8rem;\n    font-weight: 600;\n    color: #4b5563;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
